import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { useLang } from "@/i18n/LangContext";

const KEY = "sidly-cookie-consent";

export function CookieBanner() {
  const { t, to } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
    const reopen = () => setVisible(true);
    window.addEventListener("sidly:cookies", reopen);
    return () => window.removeEventListener("sidly:cookies", reopen);
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    if (value === "declined" && window.posthog?.opt_out_capturing) window.posthog.opt_out_capturing();
    if (value === "accepted" && window.posthog?.opt_in_capturing) window.posthog.opt_in_capturing();
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 40 }} transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }} className="fixed inset-x-4 bottom-4 z-[60] sm:left-auto sm:right-6 sm:w-[420px]" role="dialog" aria-live="polite" data-testid="cookie-banner">
          <div className="rounded-3xl border border-slate-200 bg-white/95 p-6 shadow-[0_30px_60px_-30px_rgba(15,23,42,0.45)] backdrop-blur-xl">
            <div className="flex items-start gap-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-teal-50 text-teal-700"><Cookie size={18} /></span>
              <div>
                <p className="font-display text-base font-semibold text-slate-900">{t.cookies.title}</p>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{t.cookies.text} <Link to={to("privacy")} className="underline decoration-teal-500 underline-offset-2 hover:text-teal-700" data-testid="cookie-more-link">{t.cookies.more}</Link></p>
              </div>
            </div>
            <div className="mt-5 flex gap-3">
              <button type="button" onClick={() => choose("accepted")} className="btn-primary flex-1 !py-2.5" data-testid="cookie-accept-button">{t.cookies.accept}</button>
              <button type="button" onClick={() => choose("declined")} className="btn-secondary flex-1 !py-2.5" data-testid="cookie-decline-button">{t.cookies.decline}</button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
